// Action Types
export const ACTIVE_INDEX_ADMIN = 'ACTIVE_INDEX_ADMIN';
export const REQUEST_ID = 'REQUEST_ID';
export const REQUEST_VALUE = 'REQUEST_VALUE';
export const PROVIDER_ID = 'PROVIDER_ID';
export const PRACTICE_DETAIL_ID = 'PRACTICE_DETAIL_ID';
export const PATIENT_ID = 'PATIENT_ID';
export const QUESTIONAIRE_ID = 'QUESTIONAIRE_ID';
export const LOGIN_DETAILS = 'LOGIN_DETAILS';
export const SCAN_DETAILS = 'SCAN_DETAILS';
export const SCAN_RESULT = 'SCAN_RESULT';
export const PARTICULAR_ENTERPRISE = 'PARTICULAR_ENTERPRISE';
export const PARTICULAR_STAFF = 'PARTICULAR_STAFF';
export const PARTICULAR_LEAD_CAPTURE = 'PARTICULAR_LEAD_CAPTURE';

// This action will simply save the details to Redux without any API call
export const basicDetailsValue = (type, details) => {
  switch (type) {
    case ACTIVE_INDEX_ADMIN:
      return {
        type: ACTIVE_INDEX_ADMIN,
        payload: details,
      };
    case REQUEST_ID:
      return {
        type: REQUEST_ID,
        payload: details,
      };
    case REQUEST_VALUE:
      return {
        type: REQUEST_VALUE,
        payload: details,
      };
    case PROVIDER_ID:
      return {
        type: PROVIDER_ID,
        payload: details,
      };
    case PRACTICE_DETAIL_ID:
      return {
        type: PRACTICE_DETAIL_ID,
        payload: details,
      };
    case PATIENT_ID:
      return {
        type: PATIENT_ID,
        payload: details,
      };
    case QUESTIONAIRE_ID:
      return {
        type: QUESTIONAIRE_ID,
        payload: details,
      };
    case LOGIN_DETAILS:
      return {
        type: LOGIN_DETAILS,
        payload: details,
      };
    case SCAN_DETAILS:
      return {
        type: SCAN_DETAILS,
        payload: details,
      };
    case SCAN_RESULT:
      return {
        type: SCAN_RESULT,
        payload: details,
      };
    case PARTICULAR_ENTERPRISE:
      return {
        type: PARTICULAR_ENTERPRISE,
        payload: details,
      };
    case PARTICULAR_STAFF:
      return {
        type: PARTICULAR_STAFF,
        payload: details,
      };
    case PARTICULAR_LEAD_CAPTURE:
      return {
        type: PARTICULAR_LEAD_CAPTURE,
        payload: details,
      };
  }
};
